module.exports = {
  OPEN: 1,
  ACCEPTED: 2,
  REJECTED: 3,
};
